var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabasespy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "DatabaseSpy",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.a{fill:#b79500}.b{fill:#fff}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 28.8c0 15.7-12.8 28.5-28.5 28.5S.3 44.5.3 28.8 13.1.3 28.8.3s28.5 12.8 28.5 28.5z",
    fill: "#f9d406"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.8 18.4c0 2.3-6.7 4.1-15 4.1s-15-1.8-15-4.1 6.7-4.1 15-4.1 15 1.8 15 4.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 12.5c-8.6 0-17.3 2.1-17.3 6.1v22.2c0 4 8.7 6.1 17.3 6.1S46 44.8 46 40.8V18.6c.1-4-8.6-6.1-17.2-6.1z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.8 21.8v19c0 1.3 5.3 3.9 15 3.9s15-2.6 15-3.9v-19c-3.1 1.9-9.1 3-15 3s-11.9-1-15-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.9 24c-3.4-.5-6.2-1.3-7.9-2.4l-.4-.3v19.5c0 1.4 3.6 2.9 8.3 3.7l.3.1V24.1l-.3-.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.9 14.3c-.8 0-1.7 0-2.5.1 1.2 1 1.8 2.2 1.7 3.5-.2 2.1-2.8 3.7-6.1 4.1 2.1.3 4.4.5 6.9.5 8.3 0 15-1.8 15-4.1-.1-2.3-6.8-4.1-15-4.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabasespy);
export default __webpack_public_path__ + "static/media/databasespy.caf6f14e6f167a006fd44b4c35eb5977.svg";
export { ForwardRef as ReactComponent };